import { render, staticRenderFns } from "./WaitSign.vue?vue&type=template&id=5b2da55c&scoped=true&"
import script from "./WaitSign.vue?vue&type=script&lang=js&"
export * from "./WaitSign.vue?vue&type=script&lang=js&"
import style0 from "./WaitSign.vue?vue&type=style&index=0&id=5b2da55c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2da55c",
  null
  
)

export default component.exports